import { api } from "@lib/orpc-client"
import useSWR from "swr"

const useBankTransferPaymentFee = () => {
    const { data, error, isLoading } = useSWR(
        'walletV2.pay.bankTransferFee',
        () => api.walletV2.pay.bankTransferFee({})
    )
    return {
        data,
        error,
        isLoading
    }
}

export default useBankTransferPaymentFee
